import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'oneTextFromList',
    standalone: false
})
export class OneTextFromListPipe implements PipeTransform {
  transform(item, value) {
    let configId;
    configId = Object.entries(value).find(
      (value1) => value1[0] === item.customId
    )[1];
    return item.options
      .find((value1) => value1.configId === configId)
      .label.find(
        (value2) =>
          value2.language ===
          item.options.find((value1) => value1.configId === configId).language
      ).text;
  }
}
